module.exports = __webpack_public_path__ + "img/gratitude-journal_B095M7KPQJ.b380bffc.jpg";